import { ResponseInterceptor } from '@tencent/iegsp-common/tools/utils/login/interceptor';
import { LoginInfoInterceptor } from './loginInfoInterceptor';

import { request, initNetworkManager, addInterceptors } from '@tencent/iegsp-common/request';

addInterceptors('responseInterceptors', [new LoginInfoInterceptor(), new ResponseInterceptor()]);

export { request, initNetworkManager };
